if (!customElements.get('andcharlie-contact-eyes')) {
  customElements.define('andcharlie-contact-eyes', class extends HTMLElement {
    connectedCallback() {
      this.cleanup?.();
      const panel = this.closest('.ac-size-foundation__contact-panel');
      if (!panel) return;
      const controller = new AbortController();
      const options = { signal: controller.signal };
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let visible = false;
      const stop = () => this.removeAttribute('data-looking');
      const update = () => {
        this.toggleAttribute('data-looking', visible && !document.hidden && !motion.matches);
      };
      const observer = new IntersectionObserver(([entry]) => {
        visible = entry.isIntersecting && entry.intersectionRatio > 0;
        update();
      }, { threshold: 0 });
      observer.observe(this);
      document.addEventListener('visibilitychange', update, options);
      motion.addEventListener('change', update, options);
      this.cleanup = () => {
        controller.abort();
        observer.disconnect();
        stop();
      };
    }

    disconnectedCallback() {
      this.cleanup?.();
    }
  });
}
